import React from "react";
import classnames from 'classnames';

import {__, sprintf} from "@wordpress/i18n";
import {dispatch} from '@wordpress/data';

import {RemovableChip} from '@woocommerce/blocks-components';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {formatPrice} from '@woocommerce/price-format';

import {useStoreCartVouchers} from "./use-store-cart-vouchers";
import './vouchers-list.scss';

const AppliedVouchersList = () => {
	const {removeAllVouchers, getAppliedVouchersList, isLoading} = useStoreCartVouchers();

	const formWrapperClass = 'wc-block-components-totals-coupon__content';

	const onVoucherRemove = (e, couponCode) => {
		e.preventDefault();

		removeAllVouchers( couponCode )
			.finally(() => dispatch( CART_STORE_KEY ).invalidateResolutionForStore());
	}

	return (
		<div className={ formWrapperClass }>
			<div className={classnames(
				"wc-block-components-totals-vouchers__content",
				"wc-block-components-totals-discounts__content"
			)}>
				<span className="wp-block-woocommerce-cart-order-summary-heading-block wc-block-cart__totals-title">{
					__('Applied coupons', 'voucherify')
				}</span>
				<div className={classnames(
					"wp-block-woocommerce-cart-order-summary-subtotal-block",
					"wc-block-components-totals-wrapper"
				)}>
					<div className="wc-block-components-totals-item">
						<ul className="wc-block-components-totals-discount__coupon-list">
							{getAppliedVouchersList().map(([couponCode, couponAmount], index) => (
								<RemovableChip
									key={ 'coupon-' + couponCode }
									className="wc-block-components-totals-discount__coupon-list-item"
									text={ <>{couponCode}: <span className={"amount-deducted"}>-{formatPrice(couponAmount * 100)}</span></> }
									screenReaderText={ sprintf(
										/* translators: %s Coupon code. */
										__( 'Coupon: %s', 'woocommerce' ),
										couponCode
									) }
									disabled={ isLoading }
									onRemove={ (e) => onVoucherRemove(e, couponCode) }
									radius="large"
									ariaLabel={ sprintf(
										/* translators: %s is a coupon code. */
										__(
											'Remove coupon "%s"',
											'woocommerce'
										),
										couponCode
									) }
								/>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AppliedVouchersList;
